import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=27f29024&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=js&"
export * from "./policy.vue?vue&type=script&lang=js&"
import style0 from "./policy.vue?vue&type=style&index=0&id=27f29024&prod&lang=css&"
import style1 from "./policy.vue?vue&type=style&index=1&id=27f29024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f29024",
  null
  
)

export default component.exports